import { ColumnDataType } from '../type';

const deleteColumn = (editable = true) => {
  return [
    ...(editable
      ? [
          {
            header: '',
            accessorKey: 'delete',
            minSize: 60,
            size: 60,
            maxSize: 60,
            dataType: ColumnDataType.delete,
          },
        ]
      : []),
  ];
};

export default deleteColumn;
